import { Component, inject, signal } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AbstractNewComponent } from '@unity/abstract/abstract-new.component';
import { CommunitiesClient, CommunityCreateDto, CreatedResponseDto } from '@unity/clients';
import { TextboxControlComponent } from '@unity/forms/textbox-control/textbox-control.component';
import { PageContainerComponent } from '@unity/layouts/page-container/page-container.component';
import { ActionCancelSharedComponent } from '@unity/shared/composed/action-cancel-shared/action-cancel-shared.component';
import { ActionSharedComponent } from '@unity/shared/composed/action-shared/action-shared.component';
import { CardNewSharedComponent } from '@unity/shared/composed/card-new-shared/card-new-shared.component';
import { optionalStringFormControl, stringFormControl } from '@unity/utils/form-controls';
import { QuickActions } from '@unity/utils/quick-actions';
import { FormGroupControlSchema, UnityRouteUrlTrees } from '@unity/utils/types';

class CommunityCreateSchema implements FormGroupControlSchema<CommunityCreateDto> {
  public name = stringFormControl();
  public area_name = optionalStringFormControl();
}

@Component({
  selector: 'unity-new-community-page',
  imports: [CardNewSharedComponent, PageContainerComponent, TextboxControlComponent, ActionSharedComponent, ActionCancelSharedComponent],
  templateUrl: './new-community-page.component.html',
  styleUrl: './new-community-page.component.scss',
})
export class NewCommunityPageComponent extends AbstractNewComponent<CommunityCreateDto, CommunityCreateSchema, CreatedResponseDto> {
  private readonly communitiesClient = inject(CommunitiesClient);

  protected override readonly $contentHeader = signal('Create New Community');

  protected override createResourceFn$ = (form: FormGroup<CommunityCreateSchema>) => this.communitiesClient.createOne(form.getRawValue());
  protected override redirectUrlFn = (response: CreatedResponseDto): UnityRouteUrlTrees => ['/community', response.id];

  protected override newControlsFn() {
    return new CommunityCreateSchema();
  }
  protected returnToDashboardAction = QuickActions.ReturnToDashboard;
}
